export const WA_LINK = "https://wa.me/6285280000955?text=" + encodeURIComponent("Halo VISION MEGA NETWORK, saya ingin konsultasi layanan internet.");

export const NAV = [
  { label: "Beranda", href: "#beranda" },
  { label: "Tentang Kami", href: "#tentang" },
  { label: "Layanan", href: "#layanan" },
  { label: "Area Layanan", href: "#area" },
  { label: "Galeri", href: "#galeri" },
  { label: "Kontak", href: "#kontak" },
];
